module.exports = __webpack_public_path__ + "img/rent-enrolled.4f28f774.svg";